import { cn } from '@/lib/utils'
import { Typo3Image } from '@/types'
import {
  BaseLink,
  ButtonIcon,
  Img,
  Richtext,
  Time,
  Title
} from '@/ui/components'
import { MEDIA } from '@spot'
import { BaseLinkProps } from '../types'

interface CardPressProps extends Omit<BaseLinkProps, 'role'> {
  isLarge?: boolean
  title?: string
  subtitle?: string
  date?: string
  image?: Typo3Image
  useCursor?: boolean
}

const CardPress = ({
  isLarge = false,
  title,
  subtitle,
  image,
  className,
  date,
  useCursor = true,
  ...props
}: CardPressProps) => {
  const cardClasses = cn(
    'group bg-neutral-200 flex flex-col h-full relative',
    isLarge && 'grid grid-cols-1 md:grid-cols-2 gap-gutter items-center',
    className
  )

  return (
    <BaseLink className={cardClasses} {...props}>
      <div
        className={cn(
          'relative aspect-video overflow-hidden',
          isLarge ? 'md:aspect-square' : ''
        )}
      >
        {image && (
          <Img
            priority={isLarge}
            className={cn('image-hover-effect h-full w-full')}
            data={image}
            sizes={`${MEDIA.tablet} 22rem, ${isLarge ? `84rem` : `25rem`}`}
            objectCover
            fill
          />
        )}
      </div>
      <div
        className={cn(
          'gap-y-md py-lg px-padding-md grid auto-rows-auto grid-cols-1 md:justify-items-start'
        )}
      >
        {/* {overline && <p className="text-neutral-400">{overline}</p>} */}
        <div
          className={cn(
            'gap-y-xs flex flex-col',
            isLarge ? 'md:max-w-140 md:text-balance' : 'max-w-80'
          )}
        >
          <Time
            className="textstyle-md-regular mb-md text-neutral-600"
            date={date}
          />
          <Title className={cn('line-clamp-3', isLarge ? 'h3 md:h2' : 'h3')}>
            {title}
          </Title>
          {subtitle && (
            <Richtext
              text={subtitle}
              className="textstyle-md-regular line-clamp-1 text-neutral-600"
            />
          )}
        </div>
      </div>
      <ButtonIcon
        icon="material-symbols:add"
        variant="filled-accent"
        className="absolute right-0 bottom-0 scale-80 opacity-0 group-hover:scale-100 group-hover:opacity-100"
      />
    </BaseLink>
  )
}

CardPress.displayName = 'CardPress'

export default CardPress
